import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  templateUrl: "./information-modal.component.html",
  styles: [".modal-body { max-height: 650px; overflow: scroll; }"],
})
export class InformationModalComponent {
  @Input() message: string;
  @Input() title: string = "Information";

  constructor(public activeModal: NgbActiveModal) {}
}
